module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-modal",
    class: {
      error: _vm.isError
    },
    attrs: {
      "id": "message-modal"
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), (!_vm.title || _vm.title === '') ? _c('h5', [_vm._v(_vm._s(_vm.$t('title')))]) : _vm._e(), _vm._v(" "), (_vm.title && _vm.title !== '') ? _c('h5', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (!_vm.message || _vm.message === '') ? _c('p', [_vm._v(_vm._s(_vm.$t('message')))]) : _vm._e(), _vm._v(" "), (_vm.message && _vm.message !== '') ? _c('p', [_vm._v(_vm._s(_vm.message))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebe18aba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/message-modal/message-modal.vue
// module id = 326
// module chunks = 0